<span
  class="iu-input-text-ui"
  tooltipPosition="top"
  tooltipZIndex="2100"
  [escape]="false"
  [hideDelay]="250"
  [iuValidationDisplay]="data?.hasValidation"
  [iuValidationDisplay.datacontainer]="this"
  [iuValidationDisplay.inputSelector]="'input.p-inputtext.input-field'"
  [iuValidationDisplay.valid]="isValid()"
  [life]="3000"
  pTooltip="{{ tooltip }}"
  [showDelay]="500"
  [style.backgroundColor]="backgroundColorCss"
  [style.display]="displayCss"
  [style.width]="overridedCSS?.width">
  @if (this.isLabelDisplay && label !== undefined && label !== null && label.trim().length > 0) {
    <label
      iu-apiz-label
      [fontSize]="overridedCSS?.labelFontSize"
      [for]="uuid"
      [isFieldOnly]="data?.isFieldOnly"
      [label]="label">
      {{ label }}
    </label>
  }

  <input
    #input
    autocomplete="off"
    data-cy="input-text"
    [attr.data-cy-columnName]="data ? data.columnName : columnName"
    [attr.value]="fieldValue"
    class="{{ mandatoryCss }}"
    [id]="uuid"
    [ngClass]="{
      'iu-field-conflict-text': hasConflict,
      'ui-corner-all input-field p-inputtext': true,
    }"
    placeholder="{{ placeHolder }}"
    [readonly]="isReadOnly"
    [style.font-size]="overridedCSS?.inputFontSize"
    [style.height]="overridedCSS?.inputHeight"
    [tabindex]="isReadOnly ? '-1' : null"
    [type]="data ? data.fieldType : 'text'"
    [(ngModel)]="fieldValue"
    (blur)="changePassWord()"
    (change)="dataChange(input.value); fieldValueChange.emit(input.value)"
    (click)="resetPassWord()"
    (contextmenu)="onContextMenu($event)"
    (input)="onUserInput($event)"
    (keydown.enter)="enterKey.emit($event)"
    (keyup)="isKeyUpTriggerable && onKeyUp($event)"
    (press)="onContextMenu($any($event))" />
  @if (hasConflict && dataStored) {
    <i
      #spanInput
      role="button"
      tabindex="0"
      [attr.title]="opConflict.iconTooltip"
      [attr.aria-label]="opConflict.iconTooltip"
      class="rtconflict fas fa-exclamation-triangle iconClass"
      (click)="showConflictPanel($event)"
      (keydown.enter)="showConflictPanel($event)"
      (keydown.space)="showConflictPanel($event)"></i>
  }
  @if (showValuePrefPanel) {
    <iu-prime-overlay #opValuePref appendTo="body" [dismissable]="false">
      <iu-value-preference-panel
        [data]="this.data"
        [dataStored]="this.dataStored"
        [fieldValue]="fieldValue"
        [overlayPanel]="opValuePref"
        [sourceComponent]="this"
        (closeEmitter)="toggleValuePreferencePanel($event)" />
    </iu-prime-overlay>
  }
</span>

<iu-field-conflict-panel #opConflict [field]="this" />
